<template>
	<!-- Outmost container -->
	<JBox class="s-h-full s-rounded-full">
		<JFlex class="s-flex-col">
			<!-- Property Title (Tags) -->
			<JFlex class="s-justify-around s-border-b-4 s-border-purple-600 s-shadow-xl">
				<JBox
					class="s-w-4/12 s-cursor-pointer s-text-center s-select-none s-transition-all s-duration-200 s-ease-in-out"
					:class="[selectedProperty === property.id ? activeClasses : inactiveClasses]"
					v-for="property in themeProperties"
					:key="`theme-property-${property.id}`"
					@click="selectProperty(property.id)"
				>
					{{ property.label }}
				</JBox>
			</JFlex>

			<slot />
		</JFlex>
	</JBox>
</template>
<script>
export default {
	data() {
		return {
			activeClasses: "s-text-2xl s-font-bold s-text-white s-bg-purple-600 s-pt-2",
			inactiveClasses: "s-text-xl s-font-medium s-py-3 s-bg-gray-200 s-text-gray-400 hover:s-bg-purple-300 hover:s-text-white"
		}
	},

	props: {
		themeProperties: {
			type: Array,
			default: () => []
		},

		selectedProperty: {
			type: String,
			default: "colors"
		}
	},

	methods: {
		selectProperty(property) {
			this.$emit("selectProperty", property)
		}
	}
}
</script>
